import { useState } from "react";
import { IFrameworkTemplateCategoryDialogProps } from "./FrameworkTemplateCategoryDialog";
import { createNewModel, FrameworkTemplateCategorySaveModel } from "./FrameworkTemplateCategoryDialog.types";
import { isNullOrWhitespace } from "../../../../common/stringOperations";
import { post, put } from "../../../../common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export default function useFrameworkTemplateCategoryDialogHooks(props: IFrameworkTemplateCategoryDialogProps) {
    const [templateModel, setTemplateModel] = useState<FrameworkTemplateCategorySaveModel>(initiateTemplateModel());
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const isEdit = !isNullOrWhitespace(templateModel.id);

    const addCategoryMutation = useDotLegalMutation(create);
    const editCategoryMutation = useDotLegalMutation(update);

    const addCategoryType = () => {
        addCategoryMutation.mutateAsync(templateModel, {
            onSuccess: (response: any) => {
                props.onDialogClose();
            },
        });
    };

    const editCategoryType = () => {
        editCategoryMutation.mutateAsync(templateModel, {
            onSuccess: (response: any) => {
                props.onDialogClose();
            },
        });
    };

    const save = async () => {
        if (!isEdit) {
            addCategoryType();
        } else {
            editCategoryType();
        }
    };

    const modelUpdater = {
        onNameChange: (name: string, twoLetterIsoLanguage: string) => {
            let temp = { ...templateModel };
            var language = temp.languages.find((x) => x.twoLetterIsoLanguage === twoLetterIsoLanguage);
            language!.name = name;
            setTemplateModel(temp);
        },
        onDescriptionChange: (description: string, twoLetterIsoLanguage: string) => {
            let temp = { ...templateModel };
            var language = temp.languages.find((x) => x.twoLetterIsoLanguage === twoLetterIsoLanguage);
            language!.description = description;
            setTemplateModel(temp);
        },
        onCustomIdChange: (customId: string) => {
            let temp = { ...templateModel };
            temp.customId = customId;
            setTemplateModel(temp);
        },
    };

    function create(saveModel: FrameworkTemplateCategorySaveModel) {
        return post<{}>(`/frameworks/templates/${props.frameworkTemplateId}/categories`, saveModel);
    }

    function update(saveModel: FrameworkTemplateCategorySaveModel) {
        return put<{}>(`/frameworks/templates/${props.frameworkTemplateId}/categories/${templateModel.id}`, saveModel);
    }

    function initiateTemplateModel(): FrameworkTemplateCategorySaveModel {
        return props.model
            ? {
                  id: props.model.id,
                  customId: props.model.customId,
                  languages: props.model.languages,
              }
            : createNewModel();
    }

    return { isEdit, templateModel, selectedTabIndex, setSelectedTabIndex, modelUpdater, save };
}
